var map = {
	"./CommonListenLrResult.vue": 83715,
	"./CommonReadRrResult.vue": 5233,
	"./CommonSpeakingKtResult.vue": 38400,
	"./CommonSpeakingLdldResult.vue": 96030,
	"./CommonSpeakingTyResult.vue": 52576,
	"./CommonTranslationTsResult.vue": 14830,
	"./CommonWriteKwResult.vue": 43204,
	"./CommonWriteMsResult.vue": 57723,
	"./CommonWritePaResult.vue": 81196,
	"./CommonWritePuResult.vue": 5933,
	"./CommonWriteSxResult.vue": 65495
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32779;